// ** Next imports
import Link from "next/link";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";

const RefundsCredits = () => (
  <Layout>
    <SEOHead title="Credits & Refunds" />

    <FaqTemplate title="Credits & Refunds">
      <FaqH>Credits</FaqH>

      <FaqP>EIN can issue credits for the following issues:</FaqP>
      <FaqP>
        <ul>
          <li>
            Installation Delay &#8211; One-time credit for Installation Charge
            <ul>
              <li>
                If your installation is delayed 3 or more business days past the
                Preferred Installation Date you selected when placing your
                order, EIN can provide a credit equal to your initial
                installation charge.
              </li>
            </ul>
          </li>
          <li>
            Service Outage &#8211; if your service is out due to a technical
            issue, a prorated one-time credit amount based on the number of 24
            hour periods the customer was without service, up to $20 off. This
            amount is based on your monthly service rate and is calculated from
            the first time you notify EIN of your outage.{" "}
            <Link href="/support">
              Click Here to Notify EIN of Outage or Service Issue.
            </Link>
          </li>

          <li>
            Billing Error &#8211; $10 one-time credit
            <ul>
              <li>
                In the event that our Billing System experiences an error and
                your account is billed incorrectly, a one-time $10 credit can be
                applied to your account. Any erroneous charges will be
                immediately refunded.
              </li>
            </ul>
          </li>

          <li>
            Speed Issue &#8211; One-time $10 credit
            <ul>
              <li>
                If your service experiences speed at least 20% lower than your
                expected up-to-speed for 48 hours or longer, EIN can provide a
                one-time credit of $10. Credit consideration begins at the time
                you alert EIN to the issue.{" "}
                <Link href="/speedtest">Click Here to Run Speed Test.</Link>
              </li>
            </ul>
          </li>
        </ul>
      </FaqP>

      <FaqH>Refunds</FaqH>

      <FaqP>
        EIN is a pay-in-advance service, and there are very limited
        opportunities for us to provide a refund. Approved refunds will be
        returned to the card that was originally used in the erroneous charge.
        Funds will return to your card or bank account in 2-5 business days,
        depending on your financial institution. If payment was made by cash
        (PayNearMe), check, or money order, the refund will be processed as a
        physical check and mailed to the primary service address on file.
      </FaqP>

      <FaqP>EIN can issue a refund for the following:</FaqP>

      <FaqP>
        <ul>
          <li>Erroneous billing charge, or duplicate billing.</li>
          <li>Cancellation of service prior to installation.</li>
        </ul>
      </FaqP>

      <FaqH>Request Credit or Refund</FaqH>

      <FaqP>
        You can request a credit or refund by contacting us using the form
        below.
      </FaqP>
    </FaqTemplate>
  </Layout>
);

export default RefundsCredits;
